// src/app/app.component.ts
import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { StartupService } from './_service/startup.service';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { AlertComponent } from './_components/alert/alert.component';
import { GlobalDialogComponent } from './_components/global-dialog/global-dialog.component';
import { AiComponent } from './_components/ai/ai.component';
import { AbandonedSessionRecoveryComponent } from './_components/abandoned-session-recovery/abandoned-session-recovery.component';
import { AiSessionService } from './_service/ai-session.service';
import { SyncCoordinatorService } from './_service/sync/sync-coordinator.service';
import { AppUpdateService } from './_service/app-update.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    ToastModule,
    ConfirmDialogModule,
    DialogModule,
    ButtonModule,
    AlertComponent,
    GlobalDialogComponent,
    AiComponent,
    AbandonedSessionRecoveryComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'NotesApp2';
  private readonly router = inject(Router);

  // Inject AI session service for app-level dialog management
  private readonly aiSessionService = inject(AiSessionService);
  aiSessionState$ = this.aiSessionService.state$;

  constructor(
    private startupService: StartupService,
    private readonly syncCoordinatorService: SyncCoordinatorService,
    private readonly appUpdateService: AppUpdateService,
  ) {
    console.log('AppComponent constructor. App Title=', this.title);
    this.appUpdateService.initialize();
  }

  ngOnInit(): void {
    this.startupService.initialize();
    //this.syncCoordinatorService.init();
  }

  onAiDialogShow(): void {
    // Can add focus management here if needed
  }

  closeAiDialog(): void {
    this.aiSessionService.closeDialog();
  }

  openAiAdmin(): void {
    this.aiSessionService.closeDialog();
    this.router.navigate(['/ai/administration']);
  }
}
